export enum ChartType {
  BAR = 1,
  HORIZONTAL_BAR = 2,
  LINE = 3,
  DONUT = 4,
  PIE = 5,
}
